import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Checkout from '../views/CheckoutView.vue'
import Login from "@/views/Login.vue";
import Error404 from "@/views/error/Error404.vue";
import Success from "@/views/SuccessView.vue";
import Admin from "@/views/AdminView.vue"
import Orders from "@/views/OrdersView.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      auth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      layout: "full",
      auth: false,
    },
  },
  {
    path: "/error-404",
    name: "error-404",
    component: Error404,
    meta: {
      layout: "full",
    },
  },
  {
    path: "*",
    redirect: "error-404",
  },
  {
    path: "/Checkout",
    name: "Checkout",
    component: Checkout,
    meta: {
      auth: true,
    },
  },
  {
    path: "/Success",
    name: "Success",
    component: Success,
    meta: {
      auth: true,
    },
    
  },
  {
    path: "/Admin",
    name: "Admin",
    component: Admin,
    meta: {
      auth: true,
    },
  },
  {
    path: "/Orders",
    name: "Orders",
    component: Orders,
    meta: {
      auth: true,
    },
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})


router.beforeEach((to, from, next) => {
  if (to.name !== "login" && !sessionStorage.getItem("token")) {
  return next({ name: "login" });
  } else {
  return next();
  }
});

export default router
